import { createTypedState, IModuleState } from '@aclass/core/storage/states/module.state';
import { List, Map } from 'immutable';

export interface IRedirectModuleState extends IModuleState {

    /**
     * Identifies that all data for search page is loaded
     */
    searchPageInitialized: boolean | null;

    /**
     * Collapsible form status
     */
    searchPageCollapsed: boolean | null;

    /**
     * Search form data
     */
    searchPageForm: Map<string, any>;

    /**
     * A list of instances
     */
    searchPageInstances: List<string>;

    /**
     * Collapsible form status
     */
    recordsSearchPageCollapsed: boolean | null;

    /**
     * Trigger to identify that search is running
     */
    recordsSearchPageLock: boolean | null;

    /**
     * Search form data
     */
    recordsSearchPageForm: Map<string, any>;

    /**
     * A list of product ids from ORM
     */
    recordsSearchPageResults: List<string>;

    /**
     * The pagination data
     */
    recordsSearchPagePagination: Map<string, number> | null;

    /**
     * The order data
     */
    recordsSearchPageOrder: Map<string, string> | null;

    /**
     * The id of chosen instance
     */
    recordsSearchPageId: string | null;

    /**
     * Create form data
     */
    createPageForm: Map<string, any>;

    /**
     * The the save button lock
     */
    createPageSaveLock: boolean | null;

    /**
     * The id of product
     */
    editPageRecordId: string | null;

    /**
     * The id of current instance
     */
    createPageInstanceId: string | null;

    /**
     * The the save button lock
     */
    editPageSaveLock: boolean | null;

    /**
     * Modal trigger
     */
    showRemoveModal: boolean | null;

    /**
     * Locks delete button
     */
    removeModalLock: boolean | null;

    /**
     * Edit form data
     */
    editPageForm: Map<string, any>;
}

export const INITIAL_REDIRECT_STATE = createTypedState<IRedirectModuleState>({
    searchPageInitialized: null,
    searchPageCollapsed: null,
    searchPageForm: { },
    searchPageInstances: [],
    recordsSearchPageCollapsed: null,
    recordsSearchPageLock: null,
    recordsSearchPageForm: { },
    recordsSearchPageResults: [],
    recordsSearchPagePagination: null,
    recordsSearchPageOrder: null,
    recordsSearchPageId: null,
    createPageForm: { },
    createPageSaveLock: null,
    editPageRecordId: null,
    createPageInstanceId: null,
    editPageSaveLock: null,
    showRemoveModal: null,
    removeModalLock: null,
    editPageForm: { },
});
